/* eslint-disable camelcase */
export default class PackingSlip {
  created_at = '';
  created_by = '';
  created_by_user = '';
  updated_by_user = '';
  packing_slip_items = [];
  sales_order_id = null;
  id = 0;
  partner = {};
  invoice = {
    order_no: ''
  };
  memo = '';
  tracking_no = '';

  constructor (packingSlipData) {
    Object.assign(this, packingSlipData)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/PackingSlip.js